import React from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import FileUploader from 'components/FileUploader/FileUploader';
import { url } from 'constants/api.constants';
import {
  getSclaAppSignaturePath,
  getSclaAppTranscriptsPath,
} from 'utils/navigation';
import SclaStepCard from '../components/steps/SclaStepCard';
import useSclaSectionPath from '../hooks/useSclaSectionPath';
import useUpdateSclaAppLetterOfRec from '../hooks/useUpdateSclaAppLetterOfRec';
import { SclaApplicationOutletContext } from './SclaAppLayout';

export default function SclaApplicationLetterOfRec() {
  const { application, setApplication, readOnly } =
    useOutletContext<SclaApplicationOutletContext>();
  const { files, isLoading, onRemove, onError, onSuccess, setIsLoading } =
    useUpdateSclaAppLetterOfRec(application, setApplication);
  const sectionPath = useSclaSectionPath();
  const navigate = useNavigate();

  return (
    <SclaStepCard
      title="Letter of rec"
      intro="Optional, but it helps. A teacher, coach or mentor shares why you would be a great fit."
      backTo={sectionPath(getSclaAppTranscriptsPath())}
      onContinue={async () => {
        navigate(sectionPath(getSclaAppSignaturePath()));
        return true;
      }}
      continueLabel="Save and continue →"
      readOnly={readOnly}
    >
      <div id="scla-rec">
      <FileUploader
        setIsLoading={setIsLoading}
        files={files}
        isLoading={isLoading}
        onRemove={onRemove}
        onError={onError}
        onSuccess={onSuccess}
        readOnly={readOnly}
        documentsOnly
        inputLabel="Upload letter of recommendation"
        hint="PDF, JPG or PNG up to 40 MB."
        url={`${url.API_URL}/scla/application/rec/${application._id}`}
      />
      </div>
    </SclaStepCard>
  );
}
